import MonthlyDailyStoreLayout from './MonthlyDailyStoreLayout';

export default MonthlyDailyStoreLayout;
